import script from "./EditNoteView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditNoteView.vue?vue&type=script&setup=true&lang=js"

import "./EditNoteView.vue?vue&type=style&index=0&id=3eb5dd40&lang=scss"

const __exports__ = script;

export default __exports__